export const INSTITUCIONES = "instituciones";
export const TITULOS = "titulos";
export const LICENCIAS_CONDUCIR = "licencias_conducir";
export const NIVELES_INGLES = "niveles_ingles";
export const DISCAPACIDADES = "discapacidades";
export const SITUACIONES_LABORALES = "situaciones_laborales";
export const ESTADOS_CIVILES = "estados_civiles";
export const RELACIONES_CYD = "relaciones_cyd";
export const NIVELES_ESTUDIOS = "niveles_estudios";